<script setup></script>

<template>
  <NuxtLayout>
    <div>
      <ToastList />
      <NuxtLoadingIndicator
        class="z-[9999]"
        color="rgb(255 200 50)"
        :height="4"
        :duration="5000"
        :throttle="0"
      />
      <NuxtPage />
    </div>
  </NuxtLayout>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(0.5rem);
}

.vs__search {
  font-size: 14px !important;
  line-height: 1.7 !important;
  width: auto !important;
min-width: 1px !important;
}

#phone-key {
  width: 100px !important;

}
#phone-key  .vs__actions {
  display: none !important;
}

#person-phone-key {
  width: 100px !important;

}
#person-phone-key  .vs__actions {
  display: none !important;
}
.vs--searchable .vs__dropdown-toggle {
  border-radius: 5px !important;
  border: 1px solid #e5e7eb !important;
}

.vs__dropdown-option--highlight {
  background: #ededed !important;
  color: #191919 !important;
}
.vs__dropdown-option--highlight:hover {
  background: #ededed !important;
  color: #191919 !important;
}
</style>
